export default __webpack_public_path__ + "static/media/Arrow.0916e57c.svg";